let variationModulePromise;

export function variationEvents() {
	const forms = document.querySelectorAll(".variations_form");
	if (!forms.length) return;

	let shouldInit = false;

	forms.forEach((form) => {
		if (form.dataset.variationEventsAttached) return;
		form.dataset.variationEventsAttached = "true";
		shouldInit = true;
	});

	if (!shouldInit) return;

	if (!variationModulePromise) {
		variationModulePromise = import("./variations.js");
	}

	variationModulePromise
		.then(({ initVariationForms }) => {
			initVariationForms();
		})
		.catch((err) => {
			console.error("Failed to load variation module:", err);
		});
}
